import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-440f028a"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-center position-absolute top-50 start-50 w-100 translate-middle" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "spinner-border text-light",
    role: "status"
  }, [
    /*#__PURE__*/_createElementVNode("span", { class: "sr-only" })
  ])
], -1 /* HOISTED */))
const _hoisted_2 = [
  _hoisted_1
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    id: "loading",
    class: _normalizeClass(["position-absolute top-0 start-0 w-100 h-100", { 'd-none': $setup.isDnone }])
  }, _hoisted_2, 2 /* CLASS */))
}